import { ChangeDetectionStrategy, Component, HostBinding, OnInit } from '@angular/core';
import { SectionComponent } from '../../components/section/section.component';


import { EditorIdDirective } from '../../../app/directives/editor-id.directive';
import { Section, SectionAttributes } from '../../../app/types/section';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';

type HeadlineSection = Section<
  {
    headline: string;
    numColumns: 4 | 8 | 12;
    align: 'left' | 'right';
    type: 'divider' | 'standard';
  } & SectionAttributes,
  [
    'headline',
    'numColumns',
    'align',
  ],
  'headline'
>;

@Component({
  selector: 'app-headline',
  styleUrls: ['./headline.component.scss'],
  templateUrl: './headline.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [EditorIdDirective, FsButtonComponent],
})
export class HeadlineComponent extends SectionComponent<HeadlineSection> implements OnInit {

  @HostBinding('attr.kb-section') private section: '' | null = null;

  public override ngOnInit(): void {
    super.ngOnInit();
    if (this.attributes.type === 'standard') {
      this.section = '';
    }
  }

}
